const MessageEventType = Object.freeze({
  FEATURE_MODE_STARTED: "FEATURE_MODE_STARTED",
  FEATURE_MODE_ENDED: "FEATURE_MODE_ENDED",
});

//This function is for legacy support
export const onStepModeModeStarted = () => {
  if (window && window.parent) {
    if (window === window.parent) {
      return;
    }
    window.parent.postMessage(
      {
        type: MessageEventType.FEATURE_MODE_STARTED,
      },
      "*"
    );
  }
};

//This function is for legacy support
export const onStepModeEnded = () => {
  if (window && window.parent) {
    if (window === window.parent) {
      return;
    }
    window.parent.postMessage(
      {
        type: MessageEventType.FEATURE_MODE_ENDED,
      },
      "*"
    );
  }
};
